export default {"src":"/_next/static/media/progress-wide.colour.c827b3d5.svg","height":366,"width":591,"blurWidth":0,"blurHeight":0};